import RotatingGradientBorder from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheetInfoCard/RotatingGradientBorder";
import { Box, Pressable } from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

import { TimeListInfoCardBody } from "./TimeListInfoCardBody";
import { TimeListInfoCardHeader } from "./TimeListInfoCardHeader";

type TimeListInfoCardProps = {
  title: string;
  subTitle: string;
  onPress?: () => void;
  icon?: React.JSX.Element;
  bodyTitle?: string;
  bodyContent?: string;
  footer?: React.JSX.Element | null;
  backgroundColor?: WhooshThemeColors;
  bodyColor?: WhooshThemeColors;
  titleColor?: WhooshThemeColors;
  courseMessage: string;
  showRotatingBorder?: boolean;
};

export const TimeListInfoCard = ({
  title,
  subTitle,
  onPress,
  icon,
  bodyTitle,
  bodyContent,
  footer,
  backgroundColor = "grayscale-200",
  bodyColor = "text-primary",
  titleColor = "text-primary",
  courseMessage,
  showRotatingBorder = false,
}: TimeListInfoCardProps) => {
  const noLowerPart = !bodyTitle && !bodyContent && !footer;

  const InfoCard = () => {
    return (
      <Pressable
        onPress={onPress}
        backgroundColor={backgroundColor}
        borderRadius={"4"}
        padding={4}
        borderBottomEndRadius={noLowerPart ? "0" : "4"}
        borderBottomStartRadius={noLowerPart ? "0" : "4"}
        width="100%"
        borderWidth={2}
        borderColor="transparent"
        marginTop={2}
        marginBottom={4}
      >
        <TimeListInfoCardHeader
          icon={icon}
          title={title}
          subTitle={subTitle}
          courseMessage={courseMessage}
          titleColor={titleColor}
          bodyColor={bodyColor}
        />
        {bodyTitle || bodyContent ? (
          <TimeListInfoCardBody
            bodyTitle={bodyTitle}
            titleColor={titleColor}
            bodyContent={bodyContent}
            bodyColor={bodyColor}
          />
        ) : null}

        {!!footer ? <Box>{footer}</Box> : null}
      </Pressable>
    );
  };

  return showRotatingBorder ? (
    <RotatingGradientBorder color={backgroundColor}>
      <InfoCard />
    </RotatingGradientBorder>
  ) : (
    <InfoCard />
  );
};
